export type SyringeType = typeof SYRINGE_TYPES[number];


export const SYRINGE_TYPES = [
  {
    name: "1ml Insulin Syringe",
    units: 100,
    imgSrc:
      "/images/u-100-insulin-syringe.png"
  },
  {
    name: "0.5ml Insulin Syringe",
    units: 50,
    imgSrc:
      "/images/u-50-insulin-syringe.png"
  },
  {
    name: "0.3ml Insulin Syringe",
    units: 30,
    imgSrc:
      "/images/u-30-insulin-syringe.png"
  },
] as const;
